<template>
    <a :href="getLink">{{ formatted['uscCategory'] === 'N/A' ? formatted['symbolName'] : formatted['contractName'] }}</a>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    raw: Object,
    formatted: Object,
    label: String,
});

const getLink = computed(() => {
    return window.route('interactive-charts.home', props.formatted.symbol);
});
</script>
